import type { PurchaseOrderTableVM } from 'ab-viewModels/purchaseOrder/purchaseOrderTable.viewModel';

import { PurchaseOrderItemCompletion } from '@acceligentllc/shared/enums/purchaseOrderItemCompletion';

export const statusDropdownOptions = [
	{ label: PurchaseOrderItemCompletion.NONE },
	{ label: PurchaseOrderItemCompletion.ALL },
	{ label: PurchaseOrderItemCompletion.PARTIALLY },
];

const CSV_HEADER = [
	'PO Number',
	'Status',
	'Date Created',
	'Date Submitted',
	'Vendor',
	'Location',
	'Total Cost ($)',
	'Equipment Code',
	'Job Number',
	'Requested By',
	'Submitted By',
	'Items Received',
	'Items Invoiced',
];

export const toCSVData = (viewModels: PurchaseOrderTableVM[]): string[][] => {
	const header: string[] = [...CSV_HEADER];

	const rows: string[][] = viewModels.map((_entry: PurchaseOrderTableVM) => {
		const _row: string[] = [
			`${_entry.orderNumber}`,
			_entry.status,
			`${_entry.dateCreated}`,
			`${_entry.dateSubmitted}`,
			_entry.vendorName,
			_entry.locationName ?? 'N/A',
			`${(+_entry.totalCost).toFixed(2)}`,
			_entry.equipmentCode ?? 'N/A',
			_entry.jobCode ?? 'N/A',
			_entry.requestedBy ?? 'N/A',
			_entry.submittedBy ?? 'N/A',
			`${_entry.itemsReceived}`,
			`${_entry.itemsInvoiced}`,
		];
		return _row;
	});

	return [header, ...rows];
};
